module.exports = __webpack_public_path__ + "img/Visa.99cfa182.svg";